<template>
    <section class="section">
        <h1 class="title is-4">Nulstil password</h1>
        <div v-if="success" class="notification is-success">
            Hvis din e-mail eksisterer i vores system,
            har vi sendt et link til nulstilling af dit password til dig.
        </div>
        <form @submit.prevent="send">
            <form-field
                is-bulma
                label="E-mail"
                :error="errors.email"
            >
                <input-text
                    is-bulma
                    v-model="form.email"
                    :error="errors.email"
                    type="email"
                />
            </form-field>

            <button
                class="button is-link"
                :class="{'is-loading': loading}"
                :disabled="loading"
                @click="send"
            >
                Send link
            </button>
            <router-link
                :to="{name: 'login'}"
                class="button is-text is-pulled-right"
            >
                Tilbage
            </router-link>
        </form>
    </section>
</template>

<script>
import { FormField, InputText } from '@elems/form'

export default {
    components: {
        FormField,
        InputText
    },
    data () {
        return {
            form: {
                email: ''
            },
            errors: {},
            success: false,
            loading: false
        }
    },
    methods: {
        send () {
            this.loading = true
            window.axios.post('/api/forgot-password', this.form)
                .then(response => {
                    this.loading = false
                    this.success = true
                    this.errors = {}
                })
                .catch(({ response }) => {
                    this.loading = false
                    this.success = false
                    this.errors = response.data.errors
                })
        }
    }
}
</script>
